import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import BadgeIcon from "@mui/icons-material/Badge";
import SchoolIcon from "@mui/icons-material/School";
import PrintIcon from "@mui/icons-material/Print";
import OneTermMarksheetReceiptBulk from "../reciept/OneTermMarksheetReceiptBulk";
import TwoPageMarksheetReceiptBulk from "../reciept/TwoPageMarksheetReceiptBulk";
import TermsMarksheetReceiptBulk from "../reciept/TermsMarksheetReceiptBulk";
import authService from "../Auth/AuthService";
// import { getAcademicYear } from "../utils/academicYear";
import { useLocation, useNavigate } from "react-router-dom";
import SinglePageMarksheetReceiptBulk from "../reciept/SinglePageMarksheetReceiptBulk";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { downloadCertificatePDF } from "../utils/experiencePDF";
import { printHtml } from "../utils/htmlToPrint";

function AnimatedTabPanel({ children, value, index }) {
  return (
    <AnimatePresence mode="wait">
      {value === index && (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.4 }}
        >
          <Box sx={{ p: 2 }}>{children}</Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default function BulkMarksheetPage({ user }) {
  const location = useLocation();
  const receiptData = location.state || [];
  const [show, setShow] = useState(true);
  const [value, setValue] = useState(0);
  const [school, setSchool] = useState([{ name: "Activity 1" }]);
  // const student = markData[0]?.classRoom[0];
  // const [studentFilter, setStudentFilter] = useState(null);
  // const [student, setStudent] = useState([]);
  // const [standards, setStandards] = useState({});
  const [temID, setTemID] = useState(null);
  // const [filename, setFilename] = useState(null);

  const hasFetched = useRef(false);
  const navigate = useNavigate();
  const DOC_URL = authService.DOC_URL

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    // setYear(getAcademicYear(new Date()))
    // loadClassRooms();
    loadSchool();
  }, []);

  const handleChange = (_, newValue) => setValue(newValue);

  // const loadClassRooms = async () => {
  //   const url = authService.pathUrl('GET', '/classroom/academic/school/' + `${user?.mas_code}` + '/' + getAcademicYear(new Date()));
  //   const res = await authService.getAuth(url);
  //   setStudentFilter(res);
  //   setStudent(res);
  //   setStandards(Array.from(new Set(res.map(r => r.standard))));
  // };

  const loadSchool = async () => {
    try {
      if (user?.mas_id !== undefined && user?.mas_id !== 'undefined') {
        const url = authService.pathUrl("GET", "/schools/" + user?.mas_id);
        const schoolsData = await authService.getAuth(url);
        const updatedForm = {
          ...schoolsData,
          logoUrl: DOC_URL + schoolsData.logoUrl
        };
        setSchool(updatedForm);
      }
    } catch (error) {
      console.error("Error fetching schools:", error);
    }
  }

  const tabs = [
    { icon: <SchoolIcon />, label: "All Term" },
    { icon: <SchoolIcon />, label: "Single Page" },
    { icon: <SchoolIcon />, label: "Final Term" },
    { icon: <SchoolIcon />, label: "Two Page" }
  ];

  const handleBack = () => {
    sessionStorage.setItem("hide", true);
    navigate(-1)
  };

  return (
    <Box sx={{ width: "100%", p: 0, backgroundColor: "#fafafa", minHeight: "100vh" }}>


      <Tabs
        value={value}
        onChange={handleChange}
        centered
        //variant="fullWidth"
        textColor="#3f2d01"
        indicatorColor="secondary"
        slotProps={{
          indicator: {
            sx: {
              backgroundColor: "#ff9800",
              height: "3px",
              borderRadius: "2px",
              transition: "background-color 0.3s ease",
            },
          },
        }}
        sx={{
          mb: 3,
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: "bold",
            flexDirection: "row",
            gap: 1,
          },
        }}
      >
        {tabs.map((tab, i) => (
          <Tab
            key={i}
            icon={
              <motion.div
                animate={{
                  scale: value === i ? 1.5 : 1,
                  color: value === i ? "#3f2d01" : "#757575",
                }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                {tab.icon}
              </motion.div>
            }
            label={tab.label}
            iconPosition="start" // 👈 keeps icon + label side-by-side
          />
        ))}
      </Tabs>
      <Box position={'absolute'} right={20} top={40}>
        <Button variant="outlined" sx={{ bgcolor: '#3f2d01', color: '#fff' }} startIcon={<ArrowBackIcon />} onClick={handleBack}>
          Back
        </Button>
      </Box>
      {
        receiptData && (<>
          {/* //  Tab 1: all term */}
          <AnimatedTabPanel value={value} index={0}>
            <OneTermMarksheetReceiptBulk receiptData={receiptData} school={school} setTemID={setTemID} />
          </AnimatedTabPanel>

          {/* //  Tab 2: one page */}
          <AnimatedTabPanel value={value} index={1}>
            <SinglePageMarksheetReceiptBulk receiptData={receiptData} school={school} setTemID={setTemID} />
          </AnimatedTabPanel>

          {/* //  Tab 3: final term */}
          <AnimatedTabPanel value={value} index={2}>
            <TermsMarksheetReceiptBulk receiptData={receiptData} school={school} setTemID={setTemID} />
          </AnimatedTabPanel>

          {/* // Tab 4: two page */}
          <AnimatedTabPanel value={value} index={3}>
            <TwoPageMarksheetReceiptBulk receiptData={receiptData} school={school} setTemID={setTemID} />
          </AnimatedTabPanel>

          <Box sx={{ textAlign: "center", mt: 3 }}>
            <Button variant="outlined" sx={{ color: "#3f2d01" }} startIcon={<PrintIcon />} onClick={() => { printHtml(temID); window.location.reload() }}>
              Print Now
            </Button>
          </Box>
        </>)
      }
    </Box >
  );
}